import { Link } from "react-router-dom";
import { works } from "../../../mocks/works";

const latest = [...works].slice(0, 6);

export default function LatestUpdates() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="text-xs font-semibold tracking-widest text-accent-500">RECENT</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            最近更新 · 追更别错过
          </h2>
          <p className="mt-2 text-sm text-foreground-400">
            实时跟进同人圈动态，第一时间掌握热作更新进度。
          </p>
        </div>
        <Link
          to="/works"
          className="flex items-center gap-1 self-start text-sm text-primary-300 transition-colors hover:text-primary-400 whitespace-nowrap"
        >
          查看更新列表
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((w) => (
          <div
            key={w.id}
            className="flex items-center gap-4 rounded-lg border border-background-300/60 bg-background-100 p-4 transition-colors hover:border-primary-500/40"
          >
            <Link to={`/work/${w.id}`} className="relative shrink-0 overflow-hidden rounded-md">
              <img
                src={w.cover}
                alt={`${w.title} 同人作品封面`}
                title={`${w.title} 最近更新`}
                loading="lazy"
                className="h-20 w-16 object-cover object-top"
              />
            </Link>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="rounded px-1.5 py-0.5 text-[10px] text-primary-300 bg-primary-500/10">{w.status}</span>
                <h3 className="truncate font-heading text-sm font-semibold text-foreground-950">
                  <Link to={`/work/${w.id}`} className="hover:text-primary-300">{w.title}</Link>
                </h3>
              </div>
              <p className="mt-1 text-xs text-foreground-400">@{w.author} · 已更新至 {w.chapters} 章</p>
              <p className="mt-1.5 text-xs text-foreground-300">{w.updated}</p>
            </div>
            <span className="flex items-center gap-1 text-xs text-primary-300">
              <i className="ri-arrow-right-up-line" />
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}